<script setup>
/* eslint-disable */
import { TRAINING_TYPES } from '@/models/chocobos'

const props = defineProps({
  chocobo: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['update-focus'])

const trainingOptions = [
  {
    type: TRAINING_TYPES.SPEED,
    title: 'Speed Focus',
    description: '60% chance to improve speed when leveling up. 20% chance for stamina improvement.',
    icon: '🏃'
  },
  {
    type: TRAINING_TYPES.STAMINA,
    title: 'Stamina Focus',
    description: '60% chance to improve stamina when leveling up. 20% chance for speed improvement.',
    icon: '💪'
  },
  {
    type: TRAINING_TYPES.BEHAVIOR,
    title: 'Behavior Focus',
    description: 'Improve behavior every 6 levels. 20% chance for speed and stamina improvements.',
    icon: '🎯'
  }
]

const updateFocus = (type) => {
  emit('update-focus', type)
}
</script>

<template>
  <div class="bg-white rounded-lg shadow p-4">
    <h3 class="text-lg font-bold mb-4">Training Focus</h3>
    
    <div class="space-y-3">
      <div
        v-for="option in trainingOptions"
        :key="option.type"
        @click="updateFocus(option.type)"
        :class="[
          'p-3 border-2 rounded-lg cursor-pointer transition-all',
          chocobo.trainingType === option.type
            ? 'border-blue-500 bg-blue-50'
            : 'border-gray-200 hover:border-blue-300'
        ]"
      >
        <div class="flex items-center space-x-3">
          <div class="text-2xl">{{ option.icon }}</div>
          <div>
            <h4 class="font-semibold">{{ option.title }}</h4>
            <p class="text-sm text-gray-600">{{ option.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>